/**
 * E-Signing Machine agreement
 */
import MachineAgreementForm from './modules/eSigning/machine/MachineAgreementForm';
new MachineAgreementForm();

/**
 * E-Signing Explosives
 */
import ExplosivePrecursorForm from './modules/eSigning/explosives/ExplosivePrecursorForm';
new ExplosivePrecursorForm();

/**
 * E-Signing Distillate
 */
 import DistillateForm from './modules/eSigning/distillate/DistillateForm';
 new DistillateForm();

/**
 * My Orders - ReOrder
 */
import ReOrder from './modules/myOrders/ReOrder';
new ReOrder();

/**
 * Discount Administration Tool
 */
import DiscountTool from './modules/discountTool/DiscountTool';
new DiscountTool();

/**
 * Transport Auction
 */
import TransportAuction from './modules/transportAuction/TransportAuction';
new TransportAuction();

